import { useState } from 'react';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var useModal = function () {
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var _b = useState(null), data = _b[0], setData = _b[1];
    var open = function (data) {
        setIsOpen(true);
        setData(data || null);
    };
    var close = function () {
        setIsOpen(false);
        setData(null);
    };
    return { isOpen: isOpen, data: data, open: open, close: close };
};
export { useModal };
